/**
 * Monitoring Dashboard Permissions
 *
 * Controls access to system monitoring and performance data
 */
enum MonitoringPermission {
  // View monitoring overview
  VIEW_OVERVIEW = 'monitoring.view_overview',

  // View slow endpoints analysis
  VIEW_SLOW_ENDPOINTS = 'monitoring.view_slow_endpoints',

  // View error logs
  VIEW_ERRORS = 'monitoring.view_errors',

  // View platform breakdown (web vs mobile)
  VIEW_PLATFORM_BREAKDOWN = 'monitoring.view_platform_breakdown',

  // View request details by ID
  VIEW_REQUEST_DETAILS = 'monitoring.view_request_details',

  // Full access to all monitoring features
  FULL_ACCESS = 'monitoring.full_access',
}

export default MonitoringPermission;
